import type { CMYKColor } from "./CMYKColor"
import type { HSLColor } from "./HSLColor"
import type { RGBColor } from "./RGBColor"

// Union type for all color formats

export type Color = CMYKColor | HSLColor | RGBColor
